import React, { useState, useEffect, useRef } from 'react';
import DropdownSelect from 'aldoo-ra/DropdownSelect';
import { getAvailableThemes, getTheme } from 'aldoo-ra/SiteTheme';
import { getThemeCssVariables } from '../../utils.js';

const CANVAS_ID = 'vbecs-canvas-root';

const applyVarsToCanvas = (theme) => {
  const el = document.getElementById(CANVAS_ID);
  if (!el) return;
  if (!theme) {
    // Remove all previously set preview vars
    Array.from(el.style).forEach((prop) => {
      if (prop.startsWith('--color-')) el.style.removeProperty(prop);
    });
    return;
  }
  const vars = getThemeCssVariables(theme);
  Object.entries(vars).forEach(([key, val]) => el.style.setProperty(key, val));
};

const ThemeSwitcher = () => {
  const [themes, setThemes] = useState([]);
  const [selected, setSelected] = useState(null);
  const originalThemeRef = useRef(null);

  useEffect(() => {
    originalThemeRef.current = getTheme();
    getAvailableThemes().then((list) => {
      if (!list?.length) return;
      setThemes(list);
      const current = getTheme();
      if (current) {
        const match = list.find(t => t._id === current._id);
        if (match) setSelected(match);
      }
    });
    // On unmount restore original
    return () => applyVarsToCanvas(null);
  }, []);

  const handleChange = (opt) => {
    if (!opt) {
      applyVarsToCanvas(null);
      setSelected(null);
      return;
    }
    setSelected(opt._theme);
    applyVarsToCanvas(opt._theme);
  };

  if (!themes.length) return null;

  const options = themes.map(t => ({
    value: t._id,
    label: t.name || t.themeID || t._id,
    _theme: t,
  }));

  const currentValue = selected ? [options.find(o => o.value === selected._id)].filter(Boolean) : [];

  return (
    <DropdownSelect
      options={options}
      value={currentValue}
      onChange={(val) => handleChange(Array.isArray(val) ? val[0] : val)}
      showCheckbox={false}
      enableResetButton
      searchEnabled
      variant="admin"
      dropdownWidth="12rem"
      placeholder="Preview theme…"
      customTrigger={
        <div className="flex items-center gap-1.5 px-2 py-1 bg-admin_neutral_1/10 hover:bg-admin_neutral_1/20 border border-admin_bordered rounded cursor-pointer transition-colors min-w-[9rem]">
          <span className="text-xs text-admin_text truncate">
            {selected?.name || selected?.themeID || 'Preview theme…'}
          </span>
          <svg className="w-3 h-3 ml-auto text-admin_text_secondary opacity-50 shrink-0" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
          </svg>
        </div>
      }
    />
  );
};

export default ThemeSwitcher;
